import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import {
 lightGreyMidias, darkGreyMidias2, redButtons, dark2,
} from '../../../config/colors.json';

export const H1 = styled.h1`
	font-family: Poppins;
    color: ${lightGreyMidias};
    font-size: 28px;
	font-weight: medium;
    line-height: 42px;
	margin-bottom: 0;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: row;

	div:last-child{
		margin-right: 0;
	}
`;

export const Item = styled.div`
	display: flex;
	align-items: center;
	color: ${darkGreyMidias2};
	margin-right: 32px;
`;

export const LinkBaseStyle = css`
	color: ${lightGreyMidias};
	font-family: Poppins;
	font-size: 12px;
	font-weight: 500;
	line-height: 18px;
	text-decoration: none;
	transition: 0.3s ease-out;
	position: relative;
	&:hover {
		transition: 0.3s ease-out;
		text-decoration: none;
		color: ${lightGreyMidias};
		opacity: 0.6;
	}
	&.is-active {
		color: ${dark2};
		@keyframes select {
			0% {
				width: 0%
			}
			100% {
				width: 100%;
			}
		}
		&:after {
			content: '';
			display: block;
			height: 3px;
			animation: select 0.2s forwards cubic-bezier(0.11, 0.41, 0.2, 0.57);
			left: 50%;
			transform: translateX(-50%);
			background-color: ${redButtons};
			position: absolute;
			bottom: -5px;
		}
	}
`;

export const LinkRoute = styled(NavLink)`
	${LinkBaseStyle}
`;

export const Link = styled.a`
	${LinkBaseStyle}
	cursor: pointer;
`;

export const LinkButton = styled.button`
	background-color: transparent;
	border: none;
	:hover {
		text-decoration: none;
		outline:none;
	}
	:focus {
		text-decoration: none;
		outline:none;
	}
	${LinkBaseStyle}
`;
